import React from 'react';

const ServicesOneABoutNeurology = () => {
   return (
      <>
         <section className="about-area pt-120 pb-90">
            <div className="container">
               <div className="row ">
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="section-title section-title-m-0 pos-rel mb-50 text-end">
                        <div className="section-icon">
                           <img className="section-back-icon back-icon-right" src="img/section/section-back-icon.png" alt="" />
                        </div>
                        <div className="section-text section-text-small pos-rel">
                           <h5>health care facility</h5>
                           <h1>Would you rather stay at home than go into a health care facility?</h1>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="facalty-text mb-50">
                        <p>
                           The department neurology is focussed on providing comprehensive and multi disciplinery care for the disorders of brain and spine to the patient by remaining at forefront of the technology in the ever evolving neurology space. Our highly skilled neuro surgery doctors treat neurological disease such as Brain injury, Head injury, Brain Tumours, Spinal Tumours, Brain haemorrhage, hydrocephalus, Nerve Injuries etc. Treatment of seizures or epilepsy as well as modern treatment for movement disorder our further specializations. With a team led by best neuro surgeons, preservation of all function, good cosmetic outcome, shorter hospital stay and avoiding pain and discomfort are considered as important as saving a patient's life. Our specialist are dedicated to this goal.
                        </p>
                     </div>
                  </div>
               </div>
               {/* <div className="row">
                  <HomeSIngleService icon="1" title="Body Surgery" border_className="service-box-border" />
                  <HomeSIngleService icon="2" title="Dental Care" border_className="service-box-border" />
                  <HomeSIngleService icon="3" title="service-content" border_className="service-box-border" />
                  <HomeSIngleService icon="4" title="Blood Cancer" border_className="service-box-border" />
                  <HomeSIngleService icon="5" title="Neurology Sargery" border_className="service-box-border" />
                  <HomeSIngleService icon="6" title="Allergic Issue" border_className="service-box-border" />
               </div> */}
            </div>
         </section>
      </>
   );
};

export default ServicesOneABoutNeurology;